module.exports = "https://www.gc-qa.gnp.com.mx/fd915cbd42d1878847d5c892c946f2ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_danos.svg
// module id = 691
// module chunks = 0